/* tslint:disable */
/* eslint-disable */
/**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccountRewardRequest
 */
export interface AccountRewardRequest {
    /**
     * 
     * @type {string}
     * @memberof AccountRewardRequest
     */
    account: string;
    /**
     * 
     * @type {number}
     * @memberof AccountRewardRequest
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof AccountRewardRequest
     */
    size: number;
}

export function AccountRewardRequestFromJSON(json: any): AccountRewardRequest {
    return AccountRewardRequestFromJSONTyped(json, false);
}

export function AccountRewardRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountRewardRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'account': json['account'],
        'page': json['page'],
        'size': json['size'],
    };
}

export function AccountRewardRequestToJSON(value?: AccountRewardRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'account': value.account,
        'page': value.page,
        'size': value.size,
    };
}


